import Component from '@glimmer/component';
import { Chip } from 'tio-ui/components/buttons';

// ---------------------------------------------------------------------------
// StatusBadge – semantic status chip with automatic intent mapping
// ---------------------------------------------------------------------------

interface StatusBadgeSignature {
  Args: {
    /** Status string to auto-map to intent (completed → success, in-progress → primary, etc.) */
    status?: string;
    /** Custom label (overrides status) */
    label?: string;
    /** Explicit intent (overrides auto-mapping) */
    intent?: 'default' | 'primary' | 'success' | 'warning' | 'danger';
  };
  Element: HTMLSpanElement;
}

export default class StatusBadge extends Component<StatusBadgeSignature> {
  get intent() {
    if (this.args.intent) return this.args.intent;
    if (this.args.status === 'completed') return 'success';
    if (this.args.status === 'in-progress') return 'primary';
    if (this.args.status === 'planned') return 'default';
    return 'default';
  }

  get label() {
    return this.args.label ?? this.args.status ?? '';
  }

  <template>
    <Chip @intent={{this.intent}} ...attributes>{{this.label}}</Chip>
  </template>
}
